import { Component, ElementRef, input, output, viewChild } from '@angular/core';
import { IconComponent } from '@components/icon/icon.component';

export type SearchInputVariant = 'desktop' | 'mobile';

@Component({
  selector: 'app-search-input-row',
  imports: [IconComponent],
  templateUrl: './search-input-row.component.html',
  styleUrl: './search-input-row.component.scss',
  host: {
    class: 'search-input-row',
    '[class.search-input-row--mobile]': "variant() === 'mobile'"
  }
})
export class SearchInputRowComponent {
  private readonly searchInput = viewChild<ElementRef<HTMLInputElement>>('searchInput');
  public readonly variant = input<SearchInputVariant>('desktop');
  public readonly query = input('');
  public readonly placeholder = input('');
  public readonly queryChange = output<string>();
  public readonly clearRequested = output<void>();

  public focus(): void {
    this.searchInput()?.nativeElement.focus();
  }

  public onInput(event: Event): void {
    this.queryChange.emit((event.target as HTMLInputElement).value);
  }

  public onClear(): void {
    this.clearRequested.emit();
  }
}
